export { CustomComponentExtension } from './custom-component.extension';
export { CUSTOM_COMPONENT_NODE_NAME } from './custom-component.model';
